import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { adminBotUpsideHanumanSocket, spotSocket } from 'src/app/app.module';
import { fraction, longDecimals, nFormatter, toFixed, toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';
import { adminHanumanUpsideService } from 'src/app/services/bot.adminHanumanUpSIde.service';
import { TradePairFacade } from 'src/app/store/bottradepair';
import { WalletService } from 'src/app/services/wallet.service';
import { AuthFacade } from 'src/app/store/auth';
import { TradeAssetFacade } from 'src/app/store/bot-trade-asset';
import { PairFacade } from 'src/app/store/botpair';
import { PositionDetailsFacade } from 'src/app/store/positionDetails';
import isEmpty from 'src/app/lib/isEmpty';
import { getDisplayedPages } from 'src/app/lib/pagination';

@Component({
  selector: 'app-hanumanUpsideOpenPosition',
  templateUrl: './openPosition.component.html',
  styleUrls: ['./openPosition.component.css']
})
export class HanumanUpsideOpenPositionComponent {
  toFixedDown = toFixedDown
  toFixed = toFixed
  truncateDecimals = truncateDecimals
  longDecimals = longDecimals
  fraction = fraction
  nFormatter = nFormatter

  pairs: any = {}
  tradePair: any = {}
  auth: any = {}
  searchPair: string = ''
  activePair: string = ''
  getDisplayedOrderPages: number[] = []
  botPositionHistory: any = {}
  cancelLoader: any = false
  isPosLoading: any = false
  orderFilter: any = {
    page: 1,
    limit: 500,
    totalPages: 0,
    pairName: "all",
    orderType: "all",
    buyorsell: "all",
    status: ""
  }
  constructor(
    private pairFacade: PairFacade,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private toastr: ToastrService,
    private service: adminHanumanUpsideService,
    private authFacade: AuthFacade,
    private walletService: WalletService,
    private tradeAssetFacade: TradeAssetFacade,
    private positionDetails: PositionDetailsFacade,
    private spotSocket: spotSocket,
    private botSocket: adminBotUpsideHanumanSocket,
    private tradePairFacade: TradePairFacade,
  ) {
    this.authFacade.auth$.subscribe({
      next: (userAuth: any) => {
        this.auth = userAuth
      },
      error: (err: any) => { }
    })
  }

  pairChange() {
    this.tradePairFacade.tradePair$.subscribe({
      next: (selectPair: any) => {
        if (!isEmpty(selectPair)) {
          let selectedSymbol = selectPair.firstCurrencySymbol + selectPair.secondCurrencySymbol
          const fullPair = this.pairs.find((v: any) => v.symbol === selectedSymbol);
          if (fullPair) this.tradePair = fullPair
          let symbol = selectPair.firstCurrencySymbol + "_" + selectPair.secondCurrencySymbol;
          this.activePair = symbol;
        }
      },
      error: (err: any) => { }
    })
  }



  getPositionHistory() {
    try {
      this.isPosLoading = true
      this.service.getPositionHistory({ filter: this.orderFilter, ordertype: "open" }).subscribe({
        next: (v: any) => {
          this.orderFilter.totalPages = Math.ceil(v?.count / this.orderFilter.limit)
          this.getDisplayedOrderPages = getDisplayedPages(this.orderFilter.page, this.orderFilter.totalPages, 5)
          let result = v?.result
          this.botPositionHistory = result

        },
        error: (err: any) => {
          console.log(err, '-------76')
        },
        complete: () => {
          this.isPosLoading = false
        },
      });
    } catch (err) {
      console.log(err, "---81");
    }
  };

  cancel(orderType: any, closeType: any, doc: any) {
    this.cancelLoader = true;
    this.toastr.success("Please wait for a while")
    // try {
    let reqData = {
      botId: doc?._id ? doc?._id : "",
      positionId: "",
      // stopMarket: true
      stopMarket: closeType == "keep",
      closeType
    };
    if (orderType == "position") {
      reqData.positionId = doc?._id ? doc?._id : ""
      reqData.botId = ""
    }
    this.service.closeBot(reqData)
      .subscribe({
        next: (v: any) => {
          this.cancelLoader = false
          if (v.status) {
            this.toastr.success(v.message)
          } else {
            this.toastr.success(v.message)
          }
        },
        error: (err: any) => {
          this.cancelLoader = false;
          if (err.error.message) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }
  cancelAndWait(orderId: any) {
    this.cancelLoader = true;
    this.toastr.success("Please wait for a while")
    // try {
    let reqData = {
      orderId
    };
    this.service.cancelAndWait(reqData)
      .subscribe({
        next: (v: any) => {
          this.cancelLoader = false
          if (v.status) {
            this.toastr.success(v.message)
          } else {
            this.toastr.success(v.message)
          }
        },
        error: (err: any) => {
          this.cancelLoader = false;
          if (err.error.message) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }
  getPairs() {
    this.pairFacade.pair$.subscribe({
      next: (pair: any) => {
        this.pairs = pair
        const fullPair = this.pairs.find((v: any) => v.symbol === this.activePair.replace("_", ""));
        if (fullPair) this.tradePair = fullPair
        this.pairChange()
      },
      error: (err: any) => { }
    })
  }
  ngOnInit() {
    this.getPairs()
    const currentPath = this.location.path();
    this.activePair = currentPath.split('/')[2];
    this.getPositionHistory()
    this.botSocket.on('marketPrice', this.marketPriceWs.bind(this))
    this.botSocket.on('botHistory', this.getPositionHistory.bind(this))

  }
  marketPriceWs(result: any) {
    if (this.botPositionHistory?.length > 0) {

      for (let item of this.botPositionHistory) {
        if ((isEmpty(item?.sellOrderId) || item?.sellOrderId?.status === 'pending' || item?.sellOrderId?.status === 'cancelWait') && item.symbol === result.symbol) {
          const markPrice = parseFloat(result?.data?.bestBid ?? result?.data?.markPrice);

          if (isEmpty(item?.sellOrderId)) {
            item.sellOrderId = {};
            item.sellOrderId.status = "cancelWait";
          }

          // Note: In your code, 'entryPrice' is actually the Total Cost (Price * Quantity)
          const entryPrice = (item?.openPrice * item?.quantity);
          let exitPrice = item?.quantity * markPrice;
          const totalFee = item?.openFee * 2;

          const orderEstProfit = (exitPrice - entryPrice) - totalFee;

          // ✅ Calculate Profit Percentage
          // Formula: (Net Profit / Total Invested Amount) * 100
          let profitPercent = 0;
          if (entryPrice > 0) {
            profitPercent = (orderEstProfit / entryPrice) * 100;
          }

          // ✅ Update the local object
          item.sellOrderId.markPrice = markPrice;
          item.esProfit = orderEstProfit.toFixed(3);
          item.profitPercent = parseFloat(profitPercent.toFixed(2)); // Storing as a number with 2 decimal precision
        }
      }

      // optional: reassign to trigger UI updates if reactive (e.g., Angular)
      this.botPositionHistory = [...this.botPositionHistory]
    }
  }
  handleSearchPair(event: any) {
    this.searchPair = event.target.value.toUpperCase().replace('/', '')
  }

  loadChart(symbol: any) {
    const originalPair = this.pairs.find((v: any) => v.symbol === symbol);
    if (!originalPair) {
      this.toastr.error("Invalid pair");
      return false;
    }

    // FIX 1: Create a shallow copy to avoid mutating the original object in 'this.pairs'.
    const fullPair = { ...originalPair };

    // FIX 2: Your logic is still hardcoded to "USDT" and will fail for other pairs.
    // (Also removed unnecessary '?' optional chaining)
    fullPair.firstCurrencySymbol = fullPair.symbol.replace("USDT", "");
    fullPair.secondCurrencySymbol = "USDT";

    this.service.setTradePair(fullPair); // Pass the new, copied object

    // FIX 3: Return true on success
    return true;
  }



  // 24H Change gainers losers sorting
  changeSort: 'gainers' | 'losers' | '' = '';

  toggleChangeSort() {
    if (this.changeSort === '') {
      this.changeSort = 'gainers';
    } else if (this.changeSort === 'gainers') {
      this.changeSort = 'losers';
    } else {
      this.changeSort = '';
    }
    this.sortPairs();
  }

  sortPairs() {
    const pairsCopy = [...this.pairs];
    if (this.changeSort === 'gainers') {
      this.pairs = pairsCopy.sort((a, b) => (b.change || 0) - (a.change || 0));
    } else if (this.changeSort === 'losers') {
      this.pairs = pairsCopy.sort((a, b) => (a.change || 0) - (b.change || 0));
    } else {
      this.pairs = pairsCopy;
    }
  }

}
